import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgWhatsappLogo = (props, ref) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 20,
	height: 20,
	fill: "none",
	viewBox: "0 0 20 20",
	ref,
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		id: "pet__logos:whatsapp-icon",
		clipPath: "url(#pet__clip0_3470_30165)",
		children: [
			/* @__PURE__ */ _jsx("path", {
				id: "pet__Vector",
				fill: "url(#pet__paint0_linear_3470_30165)",
				d: "M0.427148 9.87992C0.42668 11.5603 0.86918 13.2011 1.71059 14.6473L0.34668 19.5885L5.44293 18.2626C6.85248 19.024 8.43179 19.423 10.0367 19.4231H10.0409C15.3389 19.4231 19.6517 15.1453 19.6539 9.88744C19.655 7.33961 18.6559 4.9438 16.8407 3.14132C15.0259 1.33899 12.6122 0.345889 10.0405 0.344727C4.74184 0.344727 0.429414 4.62225 0.427227 9.87992"
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "pet__Vector_2",
				fill: "url(#pet__paint1_linear_3470_30165)",
				d: "M0.0835938 9.87721C0.0830469 11.6181 0.541406 13.3175 1.41281 14.8155L0 19.9339L5.27898 18.5605C6.73352 19.3474 8.37117 19.7622 10.0376 19.7629H10.0419C15.53 19.7629 19.9977 15.3312 20 9.88512C20.0009 7.24574 18.9659 4.7638 17.0859 2.89674C15.2057 1.02992 12.7057 0.00108527 10.0419 0C4.55281 0 0.0857813 4.43101 0.0835938 9.87721ZM3.22742 14.5575L3.03031 14.2471C2.20172 12.9398 1.76437 11.4291 1.765 9.87783C1.76672 5.35109 5.47953 1.66822 10.045 1.66822C12.2559 1.66915 14.3337 2.52434 15.8966 4.07597C17.4593 5.62775 18.3192 7.69054 18.3187 9.8845C18.3166 14.4112 14.6037 18.0946 10.0419 18.0946H10.0386C8.5532 18.0938 7.09641 17.698 5.82594 16.95L5.52359 16.7721L2.39094 17.5871L3.22742 14.5575Z"
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "pet__Vector_3",
				fill: "white",
				d: "M7.55254 5.74776C7.36613 5.33668 7.16996 5.32838 6.9927 5.32117C6.84754 5.31497 6.6816 5.31544 6.51582 5.31544C6.34988 5.31544 6.08027 5.37738 5.85238 5.62427C5.62426 5.87141 4.98145 6.46862 4.98145 7.68327C4.98145 8.898 5.87309 10.0719 5.99738 10.2368C6.12184 10.4013 7.71871 12.9737 10.2478 13.9633C12.3496 14.7857 12.7774 14.6222 13.2336 14.5809C13.6898 14.5399 14.7057 13.9839 14.913 13.4074C15.1204 12.8309 15.1204 12.3368 15.0582 12.2336C14.9961 12.1307 14.8301 12.0689 14.5813 11.9455C14.3324 11.822 13.1091 11.2247 12.8811 11.1423C12.6529 11.06 12.4871 11.0189 12.3211 11.2661C12.1552 11.513 11.6787 12.0689 11.5335 12.2336C11.3884 12.3986 11.2432 12.4192 10.9944 12.2957C10.7454 12.1718 9.9441 11.9114 8.9934 11.0704C8.25371 10.416 7.75434 9.60784 7.60918 9.36063C7.46402 9.11381 7.59363 8.98001 7.7184 8.85699C7.8302 8.74637 7.9673 8.56869 8.09184 8.42459C8.2159 8.2804 8.2573 8.17753 8.34027 8.01288C8.42332 7.84807 8.38176 7.70389 8.31965 7.5804C8.2573 7.45691 7.77379 6.2359 7.55254 5.74776Z"
			})
		]
	}), /* @__PURE__ */ _jsxs("defs", { children: [
		/* @__PURE__ */ _jsxs("linearGradient", {
			id: "pet__paint0_linear_3470_30165",
			x1: 965.71,
			x2: 965.71,
			y1: 1924.72,
			y2: .344727,
			gradientUnits: "userSpaceOnUse",
			children: [/* @__PURE__ */ _jsx("stop", { stopColor: "#1FAF38" }), /* @__PURE__ */ _jsx("stop", {
				offset: 1,
				stopColor: "#60D669"
			})]
		}),
		/* @__PURE__ */ _jsxs("linearGradient", {
			id: "pet__paint1_linear_3470_30165",
			x1: 1e3,
			x2: 1e3,
			y1: 1993.39,
			y2: 0,
			gradientUnits: "userSpaceOnUse",
			children: [/* @__PURE__ */ _jsx("stop", { stopColor: "#F9F9F9" }), /* @__PURE__ */ _jsx("stop", {
				offset: 1,
				stopColor: "white"
			})]
		}),
		/* @__PURE__ */ _jsx("clipPath", {
			id: "pet__clip0_3470_30165",
			children: /* @__PURE__ */ _jsx("rect", {
				width: 20,
				height: 20,
				fill: "white"
			})
		})
	] })]
});
const ForwardRef = forwardRef(SvgWhatsappLogo);
export default ForwardRef;
